module.exports = __webpack_public_path__ + "assets/img/hp_background.b8ae544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hp_background.png
// module id = 691
// module chunks = 1